<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    fill="none"
    stroke="currentColor"
    stroke-width="2.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="w-[36px] h-[36px] text-foregroundPrimary"
  >
    <line x1="8" y1="8" x2="28" y2="28" />
    <line x1="8" y1="28" x2="28" y2="8" />
  </svg>
</template>

<script setup>
</script>